exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loginbox{  \r\n    background: white;\r\n    color: black;    \r\n    margin-top: 15%;\r\n    margin-left: 25%;\r\n    left: 0;\r\n    padding: 20px; \r\n    box-shadow: 0 8px 50px -2px #000;\r\n    border-radius:5px;\r\n}\r\n\r\n.logo{\r\n    width: 224px; \r\n    height: 55px;\r\n    margin-left: 10%;\r\n}\r\n@media (max-width:767px) {\r\n    .loginbox{ \r\n        margin-top: 10%;\r\n        margin-left: 0%;\r\n    }    \r\n}\r\n\r\n.loginbox_content{\r\n    padding:5% 11% 5% 11%;\r\n\r\n}\r\n\r\n.singtext{\r\n    font-family: \"Open Sans\",sans-serif;\r\n    font-size: 27px;  \r\n    color: #82C226;\r\n    float: right;\r\n    padding-right: 25%;\r\n}\r\n\r\n.submit-btn{\r\n    float: right;\r\n    margin-right: 28%;\r\n}\r\n\r\n.forgotpassword{\r\n    padding-left: 10%;\r\n}\r\n@media (max-width:800px) {\r\n    .submit-btn{\r\n        \r\n        margin-right: 23%;\r\n    }\r\n\r\n   \r\n}\r\n\r\n.panel-success>.panel-heading {\r\n    color: #0E6E96;\r\n    background-color: #E3ECFB;\r\n    border-color: #E3ECFB;\r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.css
// module id = 360
// module chunks = 2